import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetAcessosPorPlataforma } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, formatarNumero, useIndicador } from '../helpers'

export default function AcessosPorPlataforma({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetAcessosPorPlataforma, filters, (d) => !d.data?.length)

  const options = {
    chart: { type: 'donut' },
    labels: data?.labels || [],
    colors: [CORES.verde, CORES.primaria, CORES.cinza],
    legend: { position: 'bottom' },
    dataLabels: { enabled: true, formatter: (percentual) => `${Math.round(percentual)}%` },
    plotOptions: {
      pie: { donut: { size: '62%', labels: { show: true, total: { show: true, label: 'Acessos', formatter: (w) => formatarNumero(w.globals.seriesTotals.reduce((a, b) => a + b, 0)) } } } },
    },
    tooltip: { y: { formatter: formatarNumero } },
  }

  return (
    <ChartCard title="Acessos por plataforma" subtitle="Android e iOS" status={status}>
      <ApexCharts options={options} series={data?.data || []} type="donut" height={280} />
    </ChartCard>
  )
}
